import styled from 'styled-components';
import { FlexContainer } from '../../styles/common/FlexBox';

export const FlexContainerCustom = styled(FlexContainer)`
    gap: 20px;

    @media (min-width: 1025px) {
        gap: 80px;
    }
`;

export const FiltersMobile = styled.div`

  @media (max-width: 768px) {
    display: flex;
    justify-content: space-between;
    padding: 0px 8px;
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    display: flex;
    justify-content: space-between;
    width: 678px;
    margin: auto;

  }
`;
